export const Page = () => {
  return (
    <div>
      <h1>Not Found</h1>
    </div>
  );
};
